App.addModule(function(app) {

    app.on('loaded', () => {

        $(document).on('click', 'img[data-toggle="zoom"]', function(event) {
		    
		    if (BS.isScreenXs()) {
			    return;
		    }
		    
		    event.preventDefault();
		    
		    var modal = app.appendModal('zoom-modal', 'modal-image');
		    
		    modal.find('.modal-content').html('<img src="'+ this.src +'"/>');
		    
		    modal.modal('show');
	    });
    })
})
